import VisibilityHelper from './visibility-helper';

export default class LazyHelper {
    /*
     * Force load of any `.lazy` images that are in the viewport and visible.
     *
     * @param {Object} lazyOptions - same as you would pass to Lazy
     * @returns {undefined}
     */
    static showLazies(showAll = false, lazyOptions = null) {
        const options = lazyOptions || { effect: 'fadeIn', effectTime: 200 };

        const sloths = document.querySelectorAll('.lazy');
        const slothsToShow = [];
        const visibilityMethod = showAll ? VisibilityHelper.isVisible : VisibilityHelper.isVisibleInViewport;
        sloths.forEach((sloth) => {
            if (visibilityMethod(sloth)) slothsToShow.push(sloth);
        });

        $(slothsToShow).Lazy(options);
    }
}
